import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export type HeadingVariants = 'h1' | 'h2' | 'h3';

export const Heading = ({
  variant,
  className,
  children,
}: {
  variant: HeadingVariants;
  className?: string;
  children?: ReactNode;
}) => {
  switch (variant) {
    case 'h1':
      return <h1 className={twMerge('font-bold', className)}>{children}</h1>;
    case 'h2':
      return <h2 className={twMerge('font-bold', className)}>{children}</h2>;
    default:
      return <h3 className={twMerge('font-bold', className)}>{children}</h3>;
  }
};
